import {isAnyOf} from '@reduxjs/toolkit'

import {getDeprecatedZipCodes} from '@web/actions/deliveryInfo'
import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {setMaximumRechargePoint} from '@web/actions/paymentMethod'
import {saveState} from '@web/actions/restoreState'
import {fetchWaitingInfo, fetchWaitingState} from '@web/actions/waiting'
import {EnhancerOptions} from '@web/helpers/redux'
import {loggingAction} from '@web/middlewares/logger'
import {pageViewAction, uiEventAction} from '@web/middlewares/uiLogging'
import {pendingPaymentAction} from '@web/slices/account/slice'
import {checkInitOrderSheetDone} from '@web/slices/common/slice'
import {recalculateAction} from '@web/slices/orderTotal/slice'

import {initOrderSheetByAPI} from '../../actions'

const isFiltering = isAnyOf(
    uiEventAction,
    pageViewAction,
    loggingAction,
    fetchWaitingInfo.fulfilled,
    fetchWaitingState.fulfilled,
    initOrderSheetByAPI.fulfilled,
    initOrderSheetByAPI.rejected,
    initOrderSheetByStorage.fulfilled,
    initOrderSheetByStorage.rejected,
    getDeprecatedZipCodes.fulfilled,
    getDeprecatedZipCodes.rejected,
    setMaximumRechargePoint.rejected,
    setMaximumRechargePoint.fulfilled,
    recalculateAction,
    pendingPaymentAction,
    checkInitOrderSheetDone,
    saveState,
)

const SmartstoreCheckoutSentryEnhancer: EnhancerOptions = {
    stateTransformer: () => {
        // 화이트 리스트 방식으로 필요한 값을 선택합니다.
        return {}
    },
    actionTransformer: (action) => {
        const actionType = action.type
        if (actionType.lastIndexOf('pending') > 0 || isFiltering(action)) {
            return null
        }
        return {
            ...action,
            payload: undefined,
        }
    },
}

export default SmartstoreCheckoutSentryEnhancer
